import useAppSelector from '../../hooks/useAppSelector';

const useStackedCalendarPropertiesEntries = () => {
  return useAppSelector((state) => state.stackedCalendar.propertiesEntries);
};

export default useStackedCalendarPropertiesEntries;
